import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=14fc9226&scoped=true"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"
import style0 from "./Patients.vue?vue&type=style&index=0&id=14fc9226&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc9226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fc9226')) {
      api.createRecord('14fc9226', component.options)
    } else {
      api.reload('14fc9226', component.options)
    }
    module.hot.accept("./Patients.vue?vue&type=template&id=14fc9226&scoped=true", function () {
      api.rerender('14fc9226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/patients/Patients.vue"
export default component.exports